import React, { useCallback } from 'react';
import { createUseStyles, DatePicker } from '@Sage/hoi-poi-ui';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { useWeb5Context } from 'lib/Web5Context';
import { formatDate, DATE_PLACEHOLDERS } from 'lib/dates';

import styles from './styles';
const useStyles = createUseStyles(styles, 'Datetime');

function Datetime({ className, ...props }) {
    const { language, locale } = useWeb5Context();
    const classes = useStyles();

    const format = useCallback(
        (value) => {
            return formatDate(value, locale);
        },
        [locale],
    );

    const placeholders = DATE_PLACEHOLDERS[locale] + ' hh:mm';
    const classNames = classnames(classes.root, className);

    return (
        <div className={classNames}>
            <DatePicker
                labelMode="horizontal"
                {...props}
                lang={language}
                formatDate={format}
                placeholder={placeholders}
            />
        </div>
    );
}

Datetime.propTypes = {
    uiGrid: PropTypes.string,
};

export default React.memo(Datetime);
